import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db, functionsEurope } from '../firebase';
import { httpsCallable } from 'firebase/functions';

const testWebhookCallable = httpsCallable(functionsEurope, 'testWebhook');

export const webhookService = {
  async getConfig(workspaceId) {
    const docRef = doc(db, 'workspace', workspaceId);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) return null;
    const data = docSnap.data();
    return {
      webhookUrl: data.webhookUrl || '',
      webhookSecret: data.webhookSecret || '',
      webhookEnabled: data.webhookEnabled || false
    };
  },

  async saveConfig(workspaceId, { webhookUrl, webhookSecret, webhookEnabled }) {
    const docRef = doc(db, 'workspace', workspaceId);
    await updateDoc(docRef, { webhookUrl, webhookSecret, webhookEnabled });
  },

  async testWebhook() {
    const { data } = await testWebhookCallable();
    return data;
  },

  generateSecret() {
    const bytes = new Uint8Array(24);
    crypto.getRandomValues(bytes);
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `whsec_${hex}`;
  }
};
